// @flow

import { mediaBreakpoints } from '@atlassian/mpac-ui/theme';
import styled from '@emotion/styled';

const HeaderCommon = `
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  display: none;
`;

export const DesktopWrapper = styled.div`
  ${HeaderCommon}
  align-items: center;
  flex-direction: row;
  @media ${mediaBreakpoints.mediumUp} {
    display: flex;
  }
`;

export const TabletWrapper = styled.div`
  ${HeaderCommon}
  @media ${mediaBreakpoints.smallOnly} {
    display: flex;
  }
`;

export const MobileWrapper = styled.div`
  ${HeaderCommon}
  @media ${mediaBreakpoints.smallDown} {
    display: flex;
  }
`;

export const WrappedLogoMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const AtlassianHeaderLogo = styled.div`
  display: flex;
  flex: 1 1 auto;
  margin: 20px 20px;

  a {
    display: flex;
    height: 30px;
    min-width: 240px;
    max-width: 300px;
  }
`;

export const AtlassianHeaderLogoImage = styled.img`
  height: 100%;
  width: 100%;
`;

export const TextSearchContainer = styled.div`
  margin-left: 20px;
  div {
    @media ${mediaBreakpoints.mediumDown} {
      margin-bottom: 10px;
    }
  }
`;
